module.exports = __webpack_public_path__ + "ml.svg?002e41cdfa805b1d34de245e611b466f";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ml.svg
// module id = 1127
// module chunks = 27